
import api from "./api";
import { AxiosInstance } from "axios";
import mockApi from "./mockApi";
import { API_CONFIG } from "../config/apiConfig";
import {
  AddContactDetailsRequest,
  InquiryDataResponse,
  SubmitContactDetailsResponse,
} from "../types/api";
const USE_MOCK_API =
  process.env.REACT_APP_USE_MOCK === "true" && API_CONFIG.IS_DEVELOPMENT;
const apiClient = USE_MOCK_API ? (mockApi as any) : (api as AxiosInstance); // TODO fix mockApi type

const contactdata = {
  getContactData: async (
    page: number = 1,
    pageSize: number = 5
  ): Promise<InquiryDataResponse> => {
    try {
      const response = await apiClient.get(
        `/api/Contact/contact_details?page=${page}&pageSize=${pageSize}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching contact data:", error);
      throw error;
    }
  },
  updatedData: async (
    updateddata: AddContactDetailsRequest
  ): Promise<SubmitContactDetailsResponse> => {
    try {
      const response = await apiClient.put("/api/Contact/inquiry", updateddata);
      return response.data;
    } catch (error) {
      console.error("Error updating contact data:", error);
      throw error;
    }
  },

  getContactbyid: async (
    contactId: string
  ): Promise<SubmitContactDetailsResponse> => {
    const response = await apiClient.get(
      `/api/Contact/contact?contactId=${contactId}`
    );
    return response.data;
  },
  submitContactUs: async (
    contactData: AddContactDetailsRequest
  ): Promise<SubmitContactDetailsResponse> => {
    try {
      const response = await apiClient.post(
        "/api/Contact/submitContactUs",
        contactData
      );
      return response.data;
    } catch (error) {
      console.error("Error submitting contact form:", error);
      throw error;
    }
  },
};

export default contactdata;
